import { PaymentReceiptForm } from "../payment-receipt-form/payment-receipt-form";
import { ReceivingCondition } from "../receiving-condition/receiving-condition";
import { OrderItem } from "./order-item";

export class Order {

  id: number;
  branchId: number;
  operatorId: number;
  inclusionDate: string;
  partnerId: number;
  totalValue: number;
  discountValue: number;
  observation: string;
  itemsCount: number;
  priceTable: number;
  operationCode: number;
  digitationDate: string;
  deliveryDate: string;
  inclusionForm: string;
  orderSituation: string;
  orderNumber: string;
  invoicedQuantity: number;
  cancelledQuantity: number;
  shippedQuantity: number;
  substitutedQuantity: number;
  quantityToShip: number;
  grossAmountInvoiced: number;
  stValue: number;
  baseStValue: number;
  ipiValue: number;
  grossWeight: number;
  liquidWeight: number;
  partnerNumberOrder: string;
  items: OrderItem[];

  // TODO - O que é isso?
  salesPerson: any;
  receivingCondition: ReceivingCondition;
  paymentReceiptForm: PaymentReceiptForm;

  static fromJson(json: any): Order {
    var temp = new Order();

    temp.id = json.ID;
    temp.branchId = json.BRANCH;
    temp.salesPerson = json.SALESPERSON;
    temp.operatorId = json.OPERATOR;
    temp.inclusionDate = json.DATA;
    temp.partnerId = json.PARTNER;
    temp.totalValue = json.TOTAL;
    temp.discountValue = json.DISCOUNT;
    temp.observation = json.OBSERVATION;
    temp.itemsCount = json.QUANTITY;
    temp.receivingCondition = json.RECEIVINGCONDITION;
    temp.paymentReceiptForm = json.PAYMENTRECEIPTFORM;
    temp.priceTable = json.PRICETABLE;
    temp.operationCode = json.CODOPER;
    temp.digitationDate = json.DIGITATIONDATE;
    temp.deliveryDate = json.DELIVERYDATE;
    temp.inclusionForm = json.INCLUSIONFORM;
    temp.orderSituation = json.ORDERSITUATION;
    temp.orderNumber = json.ORDERNUMBER;
    temp.invoicedQuantity = json.INVOICEDQUANTITY;
    temp.cancelledQuantity = json.CANCELEDQUANTITY;
    temp.shippedQuantity = json.SHIPPEDQUANTITY;
    temp.substitutedQuantity = json.SUBSTITUTEDQUANTITY;
    temp.quantityToShip = json.QUANTITYTOSHIP;
    temp.grossAmountInvoiced = json.GROSSAMOUNTINVOICED;
    temp.stValue = json.STVALUE;
    temp.baseStValue = json.BASESTVALUE;
    temp.ipiValue = json.IPIVALUE;
    temp.grossWeight = json.GROSSWEIGHT;
    temp.liquidWeight = json.LIQUIDWEIGHT;
    temp.partnerNumberOrder = json.PARTNERNUMBERORDER;
    temp.items = json.itens.map(e => OrderItem.fromJson(e));

    return temp;
  }

  static toSend(order: Order): any {
    var temp: any = {};
    temp.receivingCondition = order.receivingCondition.id;
    temp.paymentReceiptForm = order.paymentReceiptForm.id;
    temp.discount = 0;
    temp.total = order.totalValue;
    temp.quantity = order.itemsCount;
    temp.observation = null;
    temp.orderSituation = order.orderSituation;
    temp.items = order.items.map((e, index) => OrderItem.toSend(e, index + 1));
    return temp;

  }
  
}
